import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Space, Input, Row , Checkbox} from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import './location.filter.css';
import { fetchKeySearchLocation, searchLocation , fetchRegionSuggestionsInit, fetchKeySearchDynamicLocation, fetchKeySearchCompanyAndIndustries} from "../../../../redux/actions";
import { debounce } from "../../../../shared/helpers";
import { useParams } from "react-router-dom";

const CompanyFilter = (props) => {
   const dispatch = useDispatch();
   const [companyValue, setCompanyValue] = useState([]);
   const [defaultValue, setDefaultValue] = useState();
   const { id, name } = useParams();

   const [searchtext, setSearch] = useState();
   const companies = useSelector(state => state.searchSkillListingReducer.companies);
   const [checkedItems, setCheckedItems] = useState([]);
   const companyCount = localStorage.getItem("companyCountMob");


   function removeDuplicatesByValue(data) {
      const uniqueValues = new Set();
      const filteredData = [];
    
      for (const obj of data) {
        if (!uniqueValues.has(obj.value)) {
          uniqueValues.add(obj.value);
          filteredData.push(obj);
        }
      }
    
      return filteredData;
    }

   
   useEffect(() => {
    if (props.emptyCompanyInput == "" && !props.searchLocationFilter) {
      if (Object.keys(props.searchLocationFilter).length) {
        const params = {
          body: props.searchLocationFilter,
        };
        dispatch(fetchKeySearchCompanyAndIndustries(params))
      }
    }
  }, [props.emptyCompanyInput]);
   
   useEffect(() => {
      if (props.check) {
         setDefaultValue(props.check)
      }
   }, [props])

   useEffect(() => {
      var options = []
      if (companies && companies?.result) {

         for (var i = 0; i < companies?.result?.orgDetails?.[0].companies?.length; i++) {
            options = [...options,
            {
               value: companies?.result?.orgDetails?.[0].companies?.[i]?._id?.trim(), 
               count: companies?.result?.orgDetails?.[0].companies?.[i]?.count,
            }]
         }
         if (props?.check) {
            setCompanyValue(removeDuplicatesByValue([{value: props?.check,count: companyCount},...options]));
          } else {
            setCompanyValue(options);
          }
      }
   }, [companies])

   useEffect(() => {
      var options = []
      if (companies?.length > 0) {

        for (var i = 0; i < companies?.result?.orgDetails?.[0].companies?.length; i++) {
            options = [...options,
            {
               value: companies?.result?.orgDetails?.[0].companies?.[i]?._id?.trim(), 
            }]
         }
         if (props?.check) {
            setCompanyValue(removeDuplicatesByValue([{value: props?.check,count: companyCount},...options]));
          } else {
            setCompanyValue(options);
          }
      }
   }, [companies])

   const onChange = (e) => {
      props.setCheck(e.target.value);
      localStorage.setItem("companyCountMob",e.target.value2);
    
      if (props.mobileFilter) {
         props.setVisible(false)

      }
   };

   const onLocationSearch = (value) => {
    props?.setEmptyCompanyInput(value);
    let params = {}
      if(props.searchLocationFilter){
      const query = `company=${value}`
      params = {
         value: query,
         body: props.searchLocationFilter,
      };
      // dispatch(fetchKeySearchCompanyAndIndustries(params))
      }else{
         const obj = {
            value: value,
            type: "company",
          };
          params = { obj };
      }
      dispatch(fetchKeySearchCompanyAndIndustries(params))
   }

//    useEffect(()=>{
//       if(props.emptyCompanyInput == '' && !props.searchLocationFilter){
//          dispatch(fetchRegionSuggestionsInit());
//       }
//    },[props.emptyRegionInput])

//    const getCheckedValues = (value2) => {
//       if (props.checkRegionId?.includes(value2)) {
//         return true;
//       } else {
//         return false;
//       }
//     };

   return (
      <div className="location-suggestion-view" style={{overflow:"auto"}}>
         <Input
          onChange={(e) => onLocationSearch(e.target.value)} 
          className='filter-search-input'
            placeholder="Search" 
            value= {props.emptyCompanyInput}
            prefix={<SearchOutlined />}
         />
         <Space direction="vertical" style={{ width:"100%" }}>
            {!searchtext ?
               <div className={`location-lists-container ${companyValue?.length > 5 ? 'show-scrollbar' : ''}`}>
                  {companyValue?.length ? companyValue.map((items, index) => {
                     return (
                        <Radio.Group key={index} onChange={onChange} className='location-radios-grp' value={props?.check}
                        style={{width: '-webkit-fill-available'}}
                        >
                        <div style={{ display: 'flex', width: "100%", marginTop: index == 0 ? "0px" : "10px" }} key={index}>
                           <Radio 
                           type={'radio'} 
                           key={index} 
                           value={items.value}
                           value2={items?.count} 
                           className="location-radio" 
                           onChange={onChange} 
                           checked={items?.value == props?.check}
                           
                           >
                              <div style={{ display: 'flex', justifyContent: 'space-between', width: 'inherit' }}>
                                 <div>{items?.value}</div>
                                 <div className="countDiv">{props.fromCandMkt || id ? null : "("+(items?.count)+")"}</div>
                              </div>
                              </Radio>
                           {/* <Checkbox value={items.value} value2={items.value2} value3={items.value3} key={index}> {items.value}</Checkbox> */}

                           </div>
                     </Radio.Group>
                        )
                     }) : <div style={{display: 'flex', justifyContent: 'center', color: '#7e7e7e'}}> No results found </div> }
                  </div>

                   :
               searchtext.map((items,index) => {
                  return (
                     <Radio 
                     key={index} 
                     value={defaultValue? defaultValue :JSON.stringify(items)} 
                     className="location-radio" 
                    //  onChange={onChange} 
                     // checked={items?.value == props?.regionObj}
                     checked={props?.regionObj?.value?
                        items?.value == props?.regionObj?.value
                        :
                        items?.value == props?.regionObj
                        }
                     >
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: 'inherit' }}>
                                 <div>{items?.value}</div>
                                 <div className="countDiv">{props.fromCandMkt || id ? null : "("+(items?.count)+")"}</div>
                              </div>
                     </Radio>
                  )
               })
            }
         </Space>
      </div>
   )
}
export default CompanyFilter;